<template>
  <body class="w3-content" style="max-width:1200px">

  <!-- Sidebar/menu -->
  <nav class="w3-sidebar w3-bar-block w3-white w3-collapse w3-top" style="z-index:3;" id="mySidebar">
    <div class="w3-container w3-display-container w3-padding-16">
      <i v-on:click="w3_close()" class="fa fa-remove w3-hide-large w3-button w3-display-topright"></i>
      <h3 id="logo"  class="w3-wide spinInHover" v-on:click="blackOnButtonClick('home');w3_close();myAccFunc1();"><b>Τροχείο Ράπτης</b></h3>
      <!-- class="w3-spin" -->
      <img alt="icon" id="spinDisk" class="spinInHover" style="float: right;width: 75px;margin-top: -80px;" src="../assets/mini-icon.jpg">
    </div>
    <div class="w3-padding-64 w3-large w3-text-grey" style="font-weight:bold">
      <a v-on:click="blackOnButtonClick('home');w3_close();myAccFunc1();" class="w3-bar-item w3-button w3-white w3-padding-16" id="home">Εταιρεία</a>
      <a v-on:click="blackOnButtonClick('services');w3_close();myAccFunc1();" class="w3-bar-item w3-button w3-padding-16" id="services">Υπηρεσίες</a>
      <a v-on:click="myAccFunc();blackOnButtonClick('products');"  class="w3-button w3-block w3-left-align w3-padding-16" id="products">
        Προϊόντα &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i id="submenu_caret" class="fa fa-caret-down"></i>
      </a>
      <div id="demoAcc" class="w3-bar-block w3-hide w3-padding-large w3-medium w3-animate-left">
        <a class="w3-light-grey"></a>
        <a id="wood" v-on:click="grayOnButtonClick('wood');w3_close();" class="w3-bar-item w3-button">Κοπή ξύλου</a>
        <a id="metal" v-on:click="grayOnButtonClick('metal');w3_close();" class="w3-bar-item w3-button">Κοπή μετάλλου</a>
        <a id="frozen" v-on:click="grayOnButtonClick('frozen');w3_close();" class="w3-bar-item w3-button">Κοπή κατεψυγμένων</a>
        <a id="knives" v-on:click="grayOnButtonClick('knives');w3_close();" class="w3-bar-item w3-button">Μαχαίρια</a>
        <a id="rest" v-on:click="grayOnButtonClick('rest');w3_close();" class="w3-bar-item w3-button">Υπόλοιπα</a>
      </div>
      <a v-on:click="blackOnButtonClick('contact');w3_close();myAccFunc1();" class="w3-bar-item w3-button w3-padding w3-padding-16" id="contact">Επικοινωνία</a>
      <!--<a href="javascript:void(0)" class="w3-bar-item w3-button w3-padding"
         v-on:click="document.getElementById('newsletter').style.display='block'">Newsletter</a>-->
    </div>
  </nav>

  <!-- Top menu on small screens -->
  <header class="w3-bar w3-top w3-hide-large w3-black w3-xlarge">
    <div class="w3-bar-item w3-wide" style="margin-top: 1px;"><h6>Τροχείο<br>Ράπτης</h6></div>

    <a href="javascript:void(0)" class="w3-bar-item w3-button w3-padding-24 w3-right" v-on:click="w3_open()" aria-label="open menu"><i
       class="fa fa-bars"></i></a>
  </header>

  <!-- Overlay effect when opening sidebar on small screens -->
  <div class="w3-overlay w3-hide-large" v-on:click="w3_close()" style="cursor:pointer" title="close side menu"
       id="myOverlay"></div>

  <!-- !PAGE CONTENT! -->
  <div class="w3-main" style="margin-left:250px">

    <!-- Push down content on small screens -->
    <div class="w3-hide-large" style="margin-top:83px"></div>

    <!-- Top header -->
    <header class="w3-container w3-xlarge">
      <p class="w3-left" ><b id="currentLocation">Εταιρεία</b></p>
      <p class="w3-right"></p>
    </header>

    <!-- Image header -->
    <div class="w3-display-container w3-container home_container displayBlockClass">
      <vue-awsome-slider></vue-awsome-slider>
      <slideshow />
      <QuickMenu></QuickMenu>
    </div>
    <div id="home_text_area" class="home_container displayBlockClass">
      <p>Η εταιρεία <b>Ράπτης</b>  δραστηριοποιείται στον τομέα των κοπτικών εργαλείων για <b>40 και πλέον χρόνια</b>. Η εταιρεία εδρεύει στον Υμηττό
              , προσφέρει υπηρεσίες και προιόντα άριστης ποιότητας.<br><br> Η πολυετής εμπειρία μας στο χώρο των κοπτικών εργαλείων σε συνδυασμό με τον σύγχρονο
              εξοπλισμό μας κατατάσσουν την εταιρεία μας στις πιο επιτυχημένες στην Ελλάδα. Η εταιρεία παρέχει service-τρόχισμα κοπτικών
              εργαλείων και εμπορία αυτών σε όλη την Ελλάδα. Βασικοί στόχοι της εταιρείας είναι η άμεση εξυπηρέτηση των πελατών και η παροχή
              υπηρεσιών υψηλής ποιότητας. Για ο,τιδήποτε χρειαστείτε επικοινωνήστε μαζί μας.
      </p>
    </div>

    <div class="w3-display-container w3-container services_container displayNoneClass">
      <div style="margin-bottom: 150px;" class="services_category">
        <services_slideshow/>
        <p style="padding-top: 32px;padding-right: 300px;" class="services_paragraphs">
          <b>Τρόχισμα - Λείανση:</b><br/>Σκοπός μας ειναι η καλύτερη δυνατή παροχή υπηρεσιών στον τομέα τροχίσματος.
          Τρόχισμα σε όλα τα εργαλεία κοπής, <b>επαγγελματικής</b> είτε <b>ερασιτεχνικής</b> χρησης, όπως κουρευτικές μηχανές, μαχαίρια εστίασης, κορδέλες, δίσκους κλπ.
        </p>
      </div>
      <div style="margin-bottom: 150px;" class="services_category">
        <div class="w3-col l3 s6" style="max-width: 249px;min-width: 170px;width: 55.9999%!important;" id="felos_service_container">
          <div style="" class="w3-container">
            <div class="w3-display-container">
              <img alt="product thumbnail"  src="../assets/felos.jpg" style="width:100%">
            </div>
          </div>
        </div>
        <!--<div style="width: 280px;"><img alt="product thumbnail" width="100%" src="../assets/felos.jpg" id="service_image2"/></div>-->
        <p class="services_paragraphs" style="padding-top: 38px;">
          <b>Αλλαγή φελλού σε κορδέλα: </b><br/>Φελλοταινίες εξαιρετικής ποιότητας με μεγάλη αντοχή.
          Ιδανικές για κάθε είδους πριονοκορδέλα.
        </p>
      </div>
      <div class="services_category">
        <i class="fa fa-truck"  id="service_image3"></i>
        <p class="services_paragraphs" style="padding-top: 40px;padding-right: 266px;">
          <b>Εμπορία:</b><br/>Όλα μας τα προϊόντα διατίθενται και αποστέλλονται σε ολόκληρη την Ελλάδα. Χάρη στην
          πολυετή εμπειρία και την θέληση παρέχουμε σε επαγγελματία ή ερασιτέχνη ακριβώς το εργαλείο που χρειάζεται το
          ταχύτερο δυνατό. Μπορείτε να δείτε ορισμένα από τα άμεσα διαθέσιμα προιόντα στην κατηγορία των προιόντων του
          κύριου μενού.
        </p>
      </div>
    </div>

    <div class="w3-row w3-grayscale products_container wood_container displayNoneClass">
      <p class="product_paragraph">
        Ανθεκτικές κορδέλες και δίσκοι για την κοπή ξύλου. Τα προιόντα διατίθενται σε όλους τους τύπους δοντιών.
        Επικοινωνείστε μαζί μας για ενημέρωση αποθέματος.<br><b><i class="fa fa-truck"></i> Γίνεται διανομή σε όλη την Ελλάδα. </b>
      </p>
      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom00">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood11.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood1')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom01">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood21.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood2')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom02">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood31.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood3')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom03">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood41.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood4')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom04">
          <div class="w3-display-container">
            <img src="../assets/wood51.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood5')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom05">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood61.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood6')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom06">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood71.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood7')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom07">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood91.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood9')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom08">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood101.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood10')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom09">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood111.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood11')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom10">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/wood82.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('wood8')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

    </div>

    <div class="w3-row w3-grayscale products_container metal_container displayNoneClass">
      <p class="product_paragraph">
        Ανθεκτικές κορδέλες και δίσκοι για την κοπή μετάλλου. Τα προιόντα διατίθενται σε όλους τους τύπους δοντιών.
        Επικοινωνείστε μαζί μας για ενημέρωση αποθέματος.<br><b><i class="fa fa-truck"></i> Γίνεται διανομή σε όλη την Ελλάδα. </b>
      </p>
      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom00">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/metal11.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
             <button v-on:click="showmodal('metal1')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom01">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/metal21.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
             <button v-on:click="showmodal('metal2')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom02">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/metal31.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('metal3')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom02">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/metal41.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('metal4')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

    </div>

    <div class="w3-row w3-grayscale products_container frozen_container displayNoneClass">
      <p class="product_paragraph">
        Ανθεκτική κορδέλα για την κοπή κατεψυγμέμων τροφίμων. Τα προιόντα διατίθενται σε όλους τους τύπους δοντιών.
        Επικοινωνείστε μαζί μας για ενημέρωση αποθέματος.<br><b><i class="fa fa-truck"></i> Γίνεται διανομή σε όλη την Ελλάδα. </b>
      </p>
      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom00">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/frozen11.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('frozen1')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

    </div>

    <div class="w3-row w3-grayscale products_container knives_container displayNoneClass">
      <p class="product_paragraph">
        Τροχισμένα μαχαίρια πολλών ειδών.
        Επικοινωνείστε μαζί μας για ενημέρωση αποθέματος.<br><b><i class="fa fa-truck"></i> Γίνεται διανομή σε όλη την Ελλάδα. </b>
      </p>
      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom00">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/knives11.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('knives1')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom01">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/knives21.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('knives2')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom02">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/knives41.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('knives4')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom03">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/tersa_01.png" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('knives5')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom04">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/knives32.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('knives3')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

    </div>

    <div class="w3-row w3-grayscale products_container rest_container displayNoneClass">
      <p class="product_paragraph">
        Εργαλεία ρούτερ, σβούρες και υπόλοιπα εργαλεία τροχίσματος.
        Επικοινωνείστε μαζί μας για ενημέρωση αποθέματος.<br><b><i class="fa fa-truck"></i> Γίνεται διανομή σε όλη την Ελλάδα. </b>
      </p>
      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom00">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/rest11.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
             <button v-on:click="showmodal('rest1')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom01">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/rest21.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
             <button v-on:click="showmodal('rest2')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom02">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/rest61.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('rest6')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom03">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/rest31.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
             <button v-on:click="showmodal('rest3')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom04">
          <div class="w3-display-container">
            <img alt="product thumbnail" src="../assets/rest41.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
             <button v-on:click="showmodal('rest4')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom05">
          <div class="w3-display-container">
            <img alt="product thumbnail" src="../assets/rest51.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('rest5')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

      <div class="w3-col l3 s6">
        <div style="transform:scale(0);" class="w3-container w3-animate-zoom06">
          <div class="w3-display-container">
            <img alt="product thumbnail"  src="../assets/rest71.jpg" style="width:100%">
            <div class="w3-display-middle w3-display-hover">
              <button v-on:click="showmodal('rest7')" class="w3-button w3-black">Λεπτομέρειες <i class="fa fa-search"></i></button>
            </div>
          </div>
          <p></p>
        </div>
      </div>

    </div>

    <allmodals/>

    <div class="contact_container displayNoneClass" style="padding: 16px;" id="">
      <h4>Θα μας βρείτε: </h4>
      <div class="w3-cell-row">
        <div class="w3-container w3-cell w3-mobile" id="store_01">
          <p><i class="fa fa-fw fa-map-marker"></i>Κρήτης 14, Υμηττός</p>
          <p><i class="fa fa-fw fa-phone"></i> 697 721 3946</p>
          <p><i class="fa fa-fw fa-phone-square"></i> 694 206 0781</p>
          <p><i class="fa fa-fw fa-briefcase"></i> 210 975 2408</p>
          <p><i class="fa fa-fw fa-envelope"></i><a href="mailto:troxeioraptis@gmail.com?subject=EmailFromWebSite" target="_blank" rel="noopener"> troxeioraptis@gmail.com </a></p><br>
          <a href="https://www.facebook.com/dimitris.raptis.37" target="_blank" rel="noopener"><i style="font-size: 20pt!important;" class="fa fa-facebook-official w3-hover-opacity w3-large"></i></a>&nbsp;&nbsp;
          <i style="font-size: 20pt!important;" class="fa fa-google w3-hover-opacity w3-large"></i>
        </div>
        <div style="width: 60%;" class="w3-container w3-cell w3-mobile" id="contact1">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3146.133381991028!2d23.746267115322738!3d37.950671479727774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3e61776f21cf0801!2zzqTPgc6_z4fOtc6vzr8gzqHOrM-Az4TOt8-C!5e0!3m2!1sel!2sgr!4v1544558185139"
                  height="450" frameborder="0" style="width:100%;border:0;" allowfullscreen></iframe>
        </div>
        <div class="w3-container w3-cell w3-mobile" id="store_00">
          <p><i class="fa fa-fw fa-map-marker"></i>Κρήτης 14, Υμηττός</p>
          <p><i class="fa fa-fw fa-phone"></i> 697 721 3946</p>
          <p><i class="fa fa-fw fa-phone-square"></i> 694 206 0781</p>
          <p><i class="fa fa-fw fa-briefcase"></i> 210 975 2408</p>
          <p><i class="fa fa-fw fa-envelope"></i><a href="mailto:troxeioraptis@gmail.com?subject=EmailFromWebSite" target="_blank" rel="noopener"> troxeioraptis@gmail.com </a></p><br>
          <a href="https://www.facebook.com/dimitris.raptis.37" target="_blank" rel="noopener"><i style="font-size: 20pt!important;" class="fa fa-facebook-official w3-hover-opacity w3-large"></i></a>&nbsp;&nbsp;
          <i style="font-size: 20pt!important;" class="fa fa-google w3-hover-opacity w3-large"></i>
        </div>
      </div>
      <p id="author" style="font-size: 8pt; float: right;"><b><i class="fa fa-code"></i></b> Made with <i class="fa fa-heart"></i> by <a href="https://vchaldeakis.bitbucket.io" target="_blank" rel="noopener">Chaldeakis Vasilis</a> and Oikonomidou Ioanna </p>
      </div>
  </div>
  <!-- !END-OF PAGE CONTENT! -->
  </body>
</template>

<script>
  import slideshow from "./slideshow.vue";
  import Allmodals from "./allmodals";
  import services_slideshow from "./services_slideshow";
  import VueAwsomeSlider from "./VueAwsomeSlider";
  import QuickMenu from "./QuickMenu";

  export default {
    components: {
      QuickMenu,
      VueAwsomeSlider,
      Allmodals,
      slideshow,
      services_slideshow
    },
    name: 'posts',
    data () {
      return {
        previousLocation:"home",
        previousProduct:"",
        menuIsOpened: false,
        ind: 0
        /*,
        speed: 5,
        raptis: "Ράπτης"*/
      }
    },
    mounted:function(){
      this.typeWriter();
      $('.spinInHover').hover( function(){
          $('#spinDisk').addClass("w3-spin");
        },
        function(){
          $('#spinDisk').removeClass("w3-spin");
        }
      );
    },
    methods: {
      func1:function () {

      },
      typeWriter:function () {
      /*let txt = "Η εταιρεία "+this.raptis.bold()+"  δραστηριοποιείται στον τομέα των κοπτικών εργαλείων για <b>40 και πλέον χρόνια</b>. Η εταιρεία εδρεύει στον Υμηττό\n" +
        "        , προσφέρει υπηρεσίες και προιόντα άριστης ποιότητας.<br><br> Η πολυετής εμπειρία μας στο χώρο των κοπτικών εργαλείων σε συνδυασμό με τον σύγχρονο\n" +
        "        εξοπλισμό μας κατατάσσουν την εταιρεία μας στις πιο επιτυχημένες στην Ελλάδα. Η εταιρεία παρέχει service-τρόχισμα κοπτικών\n" +
        "        εργαλείων και εμπορία αυτών σε όλη την Ελλάδα. Βασικοί στόχοι της εταιρείας είναι η άμεση εξυπηρέτηση των πελατών και η παροχή\n" +
        "        υπηρεσιών υψηλής ποιότητας. Για ο,τιδήποτε χρειαστείτε επικοινωνήστε μαζί μας."
        if (this.ind < txt.length) {
          if(txt.charAt(this.ind) === "<" && txt.charAt(this.ind+1) === "b" && txt.charAt(this.ind+2) === ">"){
            let tmp_ind = this.ind +3;
            let tmp_str = "";
            while( txt.charAt(tmp_ind) !== "<"){
              tmp_str += txt.charAt(tmp_ind);
              tmp_ind++;
            }
            //console.log(tmp_str);
            tmp_str = tmp_str.bold();
            $('#home_paragraph').append(tmp_str) ;
            this.ind = tmp_ind+4;
          }else if(txt.charAt(this.ind) === "<" && txt.charAt(this.ind+1) === "b" && txt.charAt(this.ind+2) === "r" && txt.charAt(this.ind+3) === ">"){
            $('#home_paragraph').append( "<br>") ;
            this.ind += 3;
          }else{
            $('#home_paragraph').append( txt.charAt(this.ind)) ;
          }
          this.ind++;
          setTimeout(this.typeWriter, this.speed);
        }*/
      },
      myAccFunc:function() {
        var x = document.getElementById("demoAcc");
        if (x.className.indexOf("w3-show") == -1) {
          x.className += " w3-show";
          document.getElementsByClassName("fa-caret-down")[0].className =
            document.getElementsByClassName("fa-caret-down")[0].className.replace("fa-caret-down", "fa-caret-up");
        } else {
          x.className = x.className.replace(" w3-show", "");
          document.getElementsByClassName("fa-caret-up")[0].className =
            document.getElementsByClassName("fa-caret-up")[0].className.replace("fa-caret-up", "fa-caret-down");
        }
      },
      myAccFunc1:function() {
        var x = document.getElementById("demoAcc");
        if (x.className.indexOf("w3-show") == -1) {
          //nothin to do
        } else {
          x.className = x.className.replace(" w3-show", "");
          document.getElementsByClassName("fa-caret-up")[0].className =
            document.getElementsByClassName("fa-caret-up")[0].className.replace("fa-caret-up", "fa-caret-down");
        }
      },
      blackOnButtonClick:function(elem){
        let _this = this;
        /*setTimeout(function(){*/
          (document.getElementsByClassName("w3-white")[1]).className = (document.getElementsByClassName("w3-white")[1]).className.replace(" w3-white", "");
          //console.log( (document.getElementsByClassName("w3-white")[1]).className );
          document.getElementById(elem).className += " w3-white";
          switch(_this.previousLocation) {
            case "home":
              var cusid_ele = document.getElementsByClassName('home_container');
              if(elem === "products"){

              }else{
                for (var i = 0; i < cusid_ele.length; ++i) {
                  //console.log(cusid_ele[i]);
                  (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
                }
              }
              break;
            case "services":
              var cusid_ele = document.getElementsByClassName('services_container');
              if(elem === "products"){

              }else {
                for (var i = 0; i < cusid_ele.length; ++i) {
                  //console.log(cusid_ele[i]);
                  (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
                }
              }
              break;
            case "products":
              if(elem === "products"){

              }else{
                var cusid_ele = document.getElementsByClassName('products_container');
                for (var i = 0; i < cusid_ele.length; ++i) {
                  //console.log(cusid_ele[i]);
                  (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
                }
              }
              break;
            case "contact":
              if(elem === "products"){

              }else{
                var cusid_ele = document.getElementsByClassName('contact_container');
                for (var i = 0; i < cusid_ele.length; ++i) {
                  //console.log(cusid_ele[i]);
                  (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
                }
              }
              break;
          }
          switch(elem) {
            case "home":
              document.getElementById("currentLocation").innerHTML = "Εταιρεία";
              var cusid_ele = document.getElementsByClassName('home_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
              }
              _this.previousLocation = "home";
              break;
            case "services":
              document.getElementById("currentLocation").innerHTML = "Υπηρεσίες";
              var cusid_ele = document.getElementsByClassName('services_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
              }
              _this.previousLocation = "services";
              break;
            case "products":

              /*document.getElementById("currentLocation").innerHTML = "Προϊόντα";
              switch(_this.previousProduct) {
                case "wood":
                  document.getElementById("currentLocation").innerHTML = "Προϊόντα / Κοπή ξύλου";
                  var cusid_ele = document.getElementsByClassName('wood_container');
                  for (var i = 0; i < cusid_ele.length; ++i) {
                    //console.log(cusid_ele[i]);
                    (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
                  }
                  break;
                case "metal":
                  document.getElementById("currentLocation").innerHTML = "Προϊόντα / Κοπή μετάλλου";
                  var cusid_ele = document.getElementsByClassName('metal_container');
                  for (var i = 0; i < cusid_ele.length; ++i) {
                    //console.log(cusid_ele[i]);
                    (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
                  }
                  break;
                case "frozen":
                  document.getElementById("currentLocation").innerHTML = "Προϊόντα / Κοπή κατεψυγμένων";
                  var cusid_ele = document.getElementsByClassName('frozen_container');
                  for (var i = 0; i < cusid_ele.length; ++i) {
                    //console.log(cusid_ele[i]);
                    (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
                  }
                  break;
                case "knives":
                  document.getElementById("currentLocation").innerHTML = "Προϊόντα / Μαχαίρια";
                  var cusid_ele = document.getElementsByClassName('knives_container');
                  for (var i = 0; i < cusid_ele.length; ++i) {
                    //console.log(cusid_ele[i]);
                    (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
                  }
                  break;
                case "rest":
                  document.getElementById("currentLocation").innerHTML = "Προϊόντα / Υπόλοιπα";
                  var cusid_ele = document.getElementsByClassName('rest_container');
                  for (var i = 0; i < cusid_ele.length; ++i) {
                    //console.log(cusid_ele[i]);
                    (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
                  }
                  break;
              }*/
              //_this.onClickProducts();
              break;
            case "contact":
              document.getElementById("currentLocation").innerHTML = "Επικοινωνία";
              var cusid_ele = document.getElementsByClassName('contact_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
              }
              _this.previousLocation = "contact";
              break;
          }
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        /*}, 230);*/
      },
      w3_open:function() {
        //document.getElementById("mySidebar").style.display = "block";
        document.getElementById("mySidebar").style.width = "250px";
        document.getElementById("myOverlay").style.display = "block";
        this.menuIsOpened = true;
      },
      w3_close:function() {
        if(this.menuIsOpened === false){
          return;
        }
        $('#spinDisk').addClass("w3-spin01");

        setTimeout(function(){
          $('#spinDisk').removeClass("w3-spin01");
        }, 100);

        /*setTimeout(function(){*/
          document.getElementById("mySidebar").style.width = "0px";
          // document.getElementById("mySidebar").style.display = "none";
          document.getElementById("myOverlay").style.display = "none";
          this.menuIsOpened = false;
        /*},180);*/
      },
      showmodal:function(modalId){
        document.getElementById(modalId).style.display='block';
        //console.log(Allmodals.data().islideIndex +" ..")
        Allmodals.methods.icurrentSlide(Allmodals.data().islideIndex, modalId);
      },
      hidemodal:function(modalId){
        document.getElementById(modalId).style.display='none'
      },
      grayOnButtonClick:function(element){
        let _this = this;
        /*setTimeout(function(){*/
          (document.getElementsByClassName("w3-light-grey")[0]).className = (document.getElementsByClassName("w3-light-grey")[0]).className.replace("w3-light-grey", "");
          document.getElementById(element).className += " w3-light-grey";
          //console.log(_this.previousProduct + " " +element+" "+_this.previousLocation)
          switch(_this.previousProduct) {
            case "wood":
              var cusid_ele = document.getElementsByClassName('wood_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
              }
              break;
            case "metal":
              var cusid_ele = document.getElementsByClassName('metal_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
              }
              break;
            case "frozen":
              var cusid_ele = document.getElementsByClassName('frozen_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
              }
              break;
            case "knives":
              var cusid_ele = document.getElementsByClassName('knives_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
              }
              break;
            case "rest":
              var cusid_ele = document.getElementsByClassName('rest_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
              }
              break;
          }
          switch(element) {
            case "wood":
              document.getElementById("currentLocation").innerHTML = "Προϊόντα / Κοπή ξύλου";
              var my_ele = document.getElementsByClassName('wood_container');
              for (var i = 0; i < my_ele.length; ++i) {
                //console.log(my_ele[i]);
                my_ele[i].className = my_ele[i].className.replace("displayNoneClass", "");
                my_ele[i].className += " displayBlockClass";
                //console.log(my_ele[i]);
              }
              _this.previousProduct = "wood";
              break;
            case "metal":
              document.getElementById("currentLocation").innerHTML = "Προϊόντα / Κοπή μετάλλου";
              var cusid_ele = document.getElementsByClassName('metal_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                cusid_ele[i].className = cusid_ele[i].className.replace("displayNoneClass", "     displayBlockClass");

                //cusid_ele[i].style = "display:block!important;";
                //console.log(cusid_ele[i]);
              }
              _this.previousProduct = "metal";
              break;
            case "frozen":
              document.getElementById("currentLocation").innerHTML = "Προϊόντα / Κοπή κατεψυγμένων";
              var cusid_ele = document.getElementsByClassName('frozen_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
              }
              _this.previousProduct = "frozen";
              break;
            case "knives":
              document.getElementById("currentLocation").innerHTML = "Προϊόντα / Μαχαίρια";
              var cusid_ele = document.getElementsByClassName('knives_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
              }
              _this.previousProduct = "knives";
              break;
            case "rest":
              document.getElementById("currentLocation").innerHTML = "Προϊόντα / Υπόλοιπα";
              var cusid_ele = document.getElementsByClassName('rest_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayNoneClass", " displayBlockClass");
              }
              _this.previousProduct = "rest";
              break;
          }
          switch(_this.previousLocation) {
            case "home":
              var cusid_ele = document.getElementsByClassName('home_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
              }
              break;
            case "services":
              var cusid_ele = document.getElementsByClassName('services_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
              }
              break;
            case "products":
              break;
            case "contact":
              var cusid_ele = document.getElementsByClassName('contact_container');
              for (var i = 0; i < cusid_ele.length; ++i) {
                //console.log(cusid_ele[i]);
                (cusid_ele[i]).className = (cusid_ele[i]).className.replace(" displayBlockClass", " displayNoneClass");
              }
              break;
          }
          _this.previousLocation = "products";
          //_this.blackOnButtonClick('products');
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        /*},230);*/
      },

    }
  }
</script>

<style scoped>

  #author{
    margin-top: -20px;
  }

  .w3-container, .w3-panel {
    padding: 0.01em 10px;
  }

  .w3-sidebar{
    height: 110%;
  }

  #myOverlay{
    cursor: default!important;
  }

  .w3-grayscale{
    filter: grayscale(0%);
  }
  .displayNoneClass{
    display: none;
  }
  .displayBlockClass{
    display: block;
  }
  #service_image1{
    float:right;
    padding:8px;
  }
  #service_image2{
    float:left;
    padding:8px;
  }
  #service_image3{
    font-size: 115pt;
    float:right;
    padding:45px;
  }
  #service_image4{
    float:left;
    padding:8px;
  }
  #mySidebar{
    width:250px;
    transition: width .5s;
    -webkit-transition: width .5s;
  }
  #store_00{
    margin-bottom: 5%;
  }
  #store_01{
    display: none;
    margin-bottom: 5%;
  }
  #logo{
    cursor: pointer;
  }
  .product_paragraph{
    margin-left: 25px;
    margin-top: -2px;
    margin-bottom: 40px;
  }

  .w3-animate-zoom00 {
    animation: animatezoom 0.6s forwards;
    animation-delay: 0s;
  }

  .w3-animate-zoom01 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .1s;
  }

  .w3-animate-zoom02 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .2s;
  }

  .w3-animate-zoom03 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .3s;
  }

  .w3-animate-zoom04 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .4s;
  }

  .w3-animate-zoom05 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .5s;
  }

  .w3-animate-zoom06 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .6s;
  }

  .w3-animate-zoom07 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .7s;
  }

  .w3-animate-zoom08 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .8s;
  }

  .w3-animate-zoom09 {
    animation: animatezoom 0.6s forwards;
    animation-delay: .9s;
  }

  .w3-animate-zoom10 {
    animation: animatezoom 0.6s forwards;
    animation-delay: 1s;
  }

  @keyframes animatezoom{
    from{
      transform:scale(0);
    }
    to{
      transform:scale(1);
    }
  }
  .w3-spin01{
    animation:w3-spinkeyf 2s infinite linear;
  }
  @keyframes w3-spinkeyf{
    0%{
      transform:rotate(0deg)
    }
    100%{
      transform:rotate(-759deg)
    }
  }
  .w3-animate-left00{
    position:relative;
    animation:animateleft 1s;
  }
  .w3-animate-left01{
    position:relative;
    animation:animateleft 1s;
    animation-delay: 0.4s;
  }
  .w3-animate-right00{
    position:relative;
    animation:animateright 1s;
    animation-delay: 0.2s;
  }
  @keyframes animateleft{
    from{
      left:-500px;
      opacity:0.5
    }
    to{
      left:0;
      opacity:1
    }
  }
  @keyframes animateright{
    from{
      right:-500px;
      opacity:0.5
    }
    to{
      right:0;
      opacity:1
    }
  }

  @media only screen and (max-width: 860px) {
    #author{
      float: left!important;
      margin-top: 0!important;
    }
  }

  @media only screen and (max-width: 560px) {
    .services_category{
      display: grid;
      margin-bottom: 33px!important;
    }
    .services_paragraphs{
      padding-right: 0!important;
      padding-top: 1px!important;
    }
    #service_image3{
      font-size: 85pt;
      float:right;
      padding:0;
    }
    .w3-padding-64{
      padding-top: 0!important;
    }
  }

  @media only screen and (max-width: 600px) {
    #store_00{
      display: none;
    }
    #store_01{
      display: block;
    }
  }

  @media only screen and (max-width: 992px) {
    #home_text_area{
      padding-left: 18px;
      padding-right: 18px;
    }
    #mySidebar{
      width: 0px;
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue